import { useEffect, useState } from 'react';
import { SelectedTag, Tag } from './tag.jsx';
import { Icon } from '@iconify-icon/react';
import { cn } from '#lib/helpers/class.js';

export default function TagsTree(props) {
    const { tags, flattedTags, availableTags, selectedTags, selectTags } = props;
    const categories = Object.entries(tags);
    const [categoriesMap, setMap] = useState(Object.fromEntries(categories.map((arr) => [arr[0], false])) ?? {});
    useEffect(() => {
        if (categories) setMap(Object.fromEntries(categories.map((arr) => [arr[0], false])));
    }, [tags]);

    const handleCollapse = (key, collapse) => {
        const updated = structuredClone(categoriesMap);
        updated[key] = collapse;
        setMap(updated);
    };

    const handleSelectTag = (tag, checked) => {
        if (checked) return selectTags((prev) => prev.filter((p) => p.id !== tag.id));
        return selectTags((prev) => prev.concat(tag));
    };

    if (!flattedTags.length)
        return (
            <div className="w-full flex justify-center p-2 mt-4 bg-neutral-50 border border-neutral-200 rounded-lg">
                {_t.search.noTags()}
            </div>
        );

    return (
        <div className="w-full flex flex-col mt-2">
            <ul className="w-full flex flex-wrap gap-2">
                {selectedTags.map((tag) => (
                    <SelectedTag key={tag.id} tag={tag} />
                ))}
            </ul>
            <div>
                {categories.map(([key, tags]) => {
                    const collapsed = categoriesMap[key];
                    return (
                        <div key={key} className="mt-2">
                            <div className="flex justify-between items-center mb-1 pr-1">
                                <p className="font-semibold">{key}</p>
                                {collapsed ? (
                                    <Icon
                                        icon="si:expand-more-square-line"
                                        width="1.1rem"
                                        height="1.1rem"
                                        className="text-neutral-700 hover:text-neutral-900 cursor-pointer"
                                        onClick={() => handleCollapse(key, false)}
                                    />
                                ) : (
                                    <Icon
                                        icon="si:expand-less-square-line"
                                        width="1.1rem"
                                        height="1.1rem"
                                        className="text-neutral-700 hover:text-neutral-900 cursor-pointer"
                                        onClick={() => handleCollapse(key, true)}
                                    />
                                )}
                            </div>
                            <ul
                                className={cn('mb-2 flex flex-col gap-1', collapsed ? 'h-0 overflow-hidden' : 'h-auto')}
                            >
                                {tags
                                    .sort((a, b) => a.name.localeCompare(b.name))
                                    .map((tag) => {
                                        const checked = selectedTags.find((s) => s.id === tag.id) ?? false;
                                        const disabled = !checked && !availableTags.some((at) => at === tag.id);
                                        return (
                                            <Tag
                                                key={key + tag.id}
                                                checked={checked}
                                                tag={tag}
                                                handleSelectTag={handleSelectTag}
                                                disabled={disabled}
                                            />
                                        );
                                    })}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
